import { useEmailQAStore } from '@/stores/email-qa'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import {
  BarChart3,
  Star,
  CheckCircle2,
  Clock,
  TrendingUp
} from 'lucide-react'

export function QAAnalytics() {
  const { getAnalytics } = useEmailQAStore()
  const analytics = getAnalytics()

  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
      {/* Total Reviews */}
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground flex items-center gap-1">
            <BarChart3 className="h-4 w-4" />
            Gesamt
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{analytics.totalReviews}</div>
          <p className="text-xs text-muted-foreground">Reviews</p>
        </CardContent>
      </Card>

      {/* Average Rating */}
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground flex items-center gap-1">
            <Star className="h-4 w-4" />
            Ø Bewertung
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">
            {analytics.avgRating > 0 ? analytics.avgRating.toFixed(1) : '-'}
          </div>
          <p className="text-xs text-muted-foreground">von 10</p>
        </CardContent>
      </Card>

      {/* Pending */}
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground flex items-center gap-1">
            <Clock className="h-4 w-4" />
            Ausstehend
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-yellow-600">
            {analytics.pendingCount}
          </div>
          <p className="text-xs text-muted-foreground">zu bewerten</p>
        </CardContent>
      </Card>

      {/* Approved */}
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground flex items-center gap-1">
            <CheckCircle2 className="h-4 w-4" />
            Genehmigt
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-green-600">
            {analytics.approvedCount}
          </div>
          <p className="text-xs text-muted-foreground">qualitätsgeprüft</p>
        </CardContent>
      </Card>

      {/* Low Quality */}
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground flex items-center gap-1">
            <TrendingUp className="h-4 w-4" />
            Niedrige Qualität
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-red-600">
            {analytics.lowQualityCount}
          </div>
          <p className="text-xs text-muted-foreground">Rating ≤ 4</p>
        </CardContent>
      </Card>
    </div>
  )
}